function removeUndefKeys() {
  //removes undefined keys
  for (let i = 0; i < localStorage.length; i += 1) {
    const localKey = localStorage.key(i);
    if (
      localStorage.getItem(localKey) === 'undefined' ||
      localStorage.getItem(localKey) === '[]'
    )
      localStorage.removeItem(localKey);
  }
}

function removeAllKeys() {
  //removes all keys
  localStorage.clear();
}

/**
 * Function to save the selected filters in localStorage after the fetch call that used the filters has finished and returned 200 OK.
 * It also removes the undefined and empty values from localStorage to prevent errors in the app.
 *
 * @param {Object} searchValues - Object. Contains the keyNames and values of the selected filters to be saved in localStorage.
 * @param {String} location - String. Represents the current route visible in the web searchbar. It's used to create a conditional saving based on location.
 *
 * @returns {void}
 */
export default (searchValues, location) => {
  if (!searchValues || Object.keys(searchValues).length === 0) {
    removeAllKeys();
    return;
  }
  Object.keys(searchValues).forEach((filterKeyName) => {
    if (filterKeyName === 'ratingValue') {
      localStorage.setItem(
        location === '/lightPage' ? 'lightRating' : 'generalRating',
        JSON.stringify(searchValues[filterKeyName])
      );
    } else if (filterKeyName === 'subsectionId' && location?.substring(1)) {
      localStorage.setItem(
        `${location?.substring(1)}-subsectionId`,
        JSON.stringify(searchValues[filterKeyName])
      );
    } else
      localStorage.setItem(
        filterKeyName,
        JSON.stringify(searchValues[filterKeyName])
      );
  });

  removeUndefKeys();
};
